module.exports = __webpack_public_path__ + "static/media/logo-light.73f1c155.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-light.png
// module id = 566
// module chunks = 0